<template>
  <span>
    <template v-if="type == '0'">{{ date | moment }}</template>
    <template v-if="type == '1'">{{ date | momentFromNow }}</template>
    <template v-if="type == '2'">{{ date | momentJa }}</template>
    <template v-if="type == '3'">{{ date | momentDate }}</template>
    <template v-if="type == '4'">{{ date | substring(length) }}</template>
  </span>
</template>

<script>
import moment from "moment";

function toMillisecs(date) {
  if (date instanceof Object && "toDate" in date) {
    return date.toDate().getTime();
  }
  return date;
}

export default {
  props: ["date", "type", "length"],
  filters: {
    moment: function (date) {
      return moment(toMillisecs(date)).format("YYYY/MM/DD HH:mm");
    },
    momentFromNow(date) {
      moment.locale("ja");
      return moment(toMillisecs(date)).fromNow();
    },
    momentJa(date) {
      return moment(toMillisecs(date)).format("YYYY年MM月DD日 HH:mm");
    },
    momentDate(date) {
      return moment(toMillisecs(date)).format("YYYY年MM月DD日");
    },
    substring(date, length) {
      return toMillisecs(date).substring(0, length);
    },
  },
};
</script>
